module.exports = __webpack_public_path__ + "static/media/company-logo.b489d366.png";